module.exports = __webpack_public_path__ + "738f0a297d3b9e658ee3d8aa9c0b8da5.png";